import React, { useEffect, useState } from 'react';
import { Modal, Button, createStyles, TextInput, Text, Image, Card, } from "@mantine/core";
import { DatePicker } from '@mantine/dates';
import emailjs from 'emailjs-com';
import axios from 'axios';

const useStyles = createStyles((theme) => ({
    root: {
        position: 'relative',
    },

    input: {
        height: 'auto',
        paddingTop: 18,
    },

    label: {
        position: 'absolute',
        pointerEvents: 'none',
        fontSize: theme.fontSizes.xs,
        paddingLeft: theme.spacing.sm,
        paddingTop: theme.spacing.sm / 2,
        zIndex: 1,
    },

    button: {
        position: 'relative',
        transition: 'background-color 150ms ease',
    },

    progress: {
        position: 'absolute',
        bottom: -1,
        right: -1,
        left: -1,
        top: -1,
        height: 'auto',
        backgroundColor: 'transparent',
        zIndex: 0,
    },

    labelSend: {
        position: 'relative',
        zIndex: 1,
    },
}));

const BookingModal = (props) => {
    const { classes, theme } = useStyles();
    const [data, setData] = useState([]);


    const getCarsRandom = async () => {
        try {
            let url = `https://cars-rent-api.herokuapp.com/cars/?limit=47&offset=0&`;
            const resp = await axios.get(url);
            setData(resp.data.data);

        } catch (error) {
            console.log(error);
        }

    };

    let randomCarTitle = data.map((product) => product.title);
    let randomCarModel = data.map((product) => product.model);
    let randomCarImage = data.map((product) => product.image);

    useEffect(() => {
        getCarsRandom();
    }, []);

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('Rent car', 'rent', e.target, 'odsT7xBoF4sn-LYNF')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    };
    let selfRandom = () => {
        return Math.floor(Math.random() * (47 - 0 + 1)) + 0;
    };
    let randomNumber = selfRandom();

    return (
        <>

            <Modal
                opened={props.opened}
                onClose={() => props.setOpened(false)}
                title="Fast order!"
                transition="rotate-left"
                duration={300}
                size="sm"
                overlayBlur={2}
            >
                <Card withBorder radius="md" className={classes.card}>
                    <Card.Section className={classes.imageSection}>
                        <Image src={randomCarImage[randomNumber]} alt={randomCarTitle[randomNumber]} />
                    </Card.Section>
                    <Text>{randomCarTitle[randomNumber]} {randomCarModel[randomNumber]}</Text>
                </Card>


                <form onSubmit={sendEmail}>
                    <TextInput label="Your car" defaultValue={randomCarTitle[randomNumber] + ' ' + randomCarModel[randomNumber]} classNames={classes} name='car' />
                    <TextInput label="Your name" placeholder="What your name?" classNames={classes} name='name' style={{ marginTop: 20 }} />
                    <TextInput label="Your address" placeholder="Rivne, 33000" classNames={classes} style={{ marginTop: 20 }} name='address' />
                    <DatePicker
                        style={{ marginTop: 20 }}
                        label="Departure date"
                        placeholder="When you want to order?"
                        classNames={classes}
                        clearable={true}
                        name="departure"
                        defaultValue={new Date()}
                        minDate={new Date()}
                    />
                    <Button
                        type="submit"
                        style={{ marginTop: 20 }}
                        fullWidth
                        className={classes.button}
                        onClick={() => {

                            setTimeout(() => {
                                props.setOpened(false);
                            }, 2000);

                        }}

                    >
                        Apply
                    </Button>
                </form>
            </Modal>
        </>
    );
}

export default BookingModal;
